@if (currentScreen === 'success') {
  <app-cart-success
    [boughtCouponAmount]="boughtCouponAmount"></app-cart-success>
} @else if (currentScreen === 'formular') {
  <app-cart-invoice-formular
    (boughtCouponAmount)="
      (boughtCouponAmount === $event)
    "></app-cart-invoice-formular>
} @else if (currentScreen === 'cart') {
  <div class="page-container gap-24 font-color-black">
    <div class="back-button-container">
      <button class="back-button" (click)="location.back()">
        <i class="fa-regular fa-arrow-left"></i>
      </button>
    </div>
    <div class="page-title">
      <span class="font-bold-display-medium"> Einkaufswagen </span>
    </div>
    <div class="main-content">
      @if (cartService.getItems().length === 0) {
        <div class="empty-cart">
          <div class="empty-cart-icon">
            <i class="fa-regular fa-cart-circle-xmark"></i>
          </div>
          <span class="font-regular-title-large">
            Dein Warenkorb ist noch leer.
          </span>
        </div>
      } @else if (isLoading === true) {
        @for (item of cartService.getItems(); track $index) {
          <p-skeleton width="100%" height="164px"></p-skeleton>
        }
      } @else {
        @for (item of cartService.getItems(); track $index) {
          <div class="flex-c gap-12">
            <div class="flex-r gap-16 align-center">
              <app-coupon
                class="flex-1-1-0"
                [coupon]="item.product"
                [amount]="item.amount"
                [cartView]="true"
                (changeAmount)="changeAmount($event)"
                (couponDeleted)="removeFromCart(item)"></app-coupon>
              <button class="circle-large" (click)="removeFromCart(item)">
                <div class="circle-icon">
                  <i class="fa-regular fa-trash-can fa-xl"></i>
                </div>
              </button>
            </div>
            <div class="flex-r align-center justify-end gap-10 subtotal">
              <span class="font-medium-title-regular"> Subtotal: </span>
              <span class="font-medium-title-regular">
                {{ item.amount * item.product.payedAmount | currency: 'EUR' }}
              </span>
            </div>
          </div>
        }
        <div class="flex-c align-center justify-center gap-24 w-full">
          <div class="flex-r align-center justify-end gap-10 w-full total">
            <span class="font-bold-title-large"> Total: </span>
            <span class="font-bold-title-large">
              {{ cartService.getTotalAmount() | currency: 'EUR' }}
            </span>
          </div>
        </div>

        @if (!userService.currentUser$.value) {
          <div class="flex-r justify-center">
            <button
              type="button"
              class="inwi-text-button-large-primary"
              (click)="toLogin()">
              <div class="button-content">
                <div class="button-text">Anmelden zum fortfahren</div>
              </div>
            </button>
          </div>
        }

        <button
          type="button"
          class="inwi-text-button-medium-primary checkout-button"
          (click)="toInvoiceFormular()">
          <div class="button-content">
            <div class="button-text">Kauf abschließen</div>
          </div>
        </button>
      }
    </div>
  </div>
} @else {
  <div class="page-container gap-24 font-color-black">
    <div class="back-button-container">
      <button class="back-button" (click)="location.back()">
        <i class="fa-regular fa-arrow-left"></i>
      </button>
    </div>
    <div class="page-title">
      <span class="font-bold-display-medium"> Einkaufswagen </span>
    </div>
    <div class="main-content">
      @if (cartService.getItems().length === 0) {
        <div class="empty-cart">
          <div class="empty-cart-icon">
            <i class="fa-regular fa-cart-circle-xmark"></i>
          </div>
          <span class="font-regular-title-large">
            Dein Warenkorb ist noch leer.
          </span>
        </div>
      } @else {
        @for (item of cartService.getItems(); track $index) {
          <div class="flex-c gap-12">
            <div class="flex-r gap-16 align-center">
              <app-coupon
                class="flex-1-1-0"
                [coupon]="item.product"
                [amount]="item.amount"
                [cartView]="true"
                (changeAmount)="changeAmount($event)"
                (couponDeleted)="removeFromCart(item)"></app-coupon>
              <button class="circle-large" (click)="removeFromCart(item)">
                <div class="circle-icon">
                  <i class="fa-regular fa-trash-can fa-xl"></i>
                </div>
              </button>
            </div>
            <div class="flex-r align-center justify-end gap-10 subtotal">
              <span class="font-medium-title-regular"> Subtotal: </span>
              <span class="font-medium-title-regular">
                {{ item.amount * item.product.payedAmount | currency: 'EUR' }}
              </span>
            </div>
          </div>
        }
        <div class="flex-c align-center justify-center gap-24 w-full">
          <div class="flex-r align-center justify-end gap-10 w-full total">
            <span class="font-bold-title-large"> Total: </span>
            <span class="font-bold-title-large">
              {{ cartService.getTotalAmount() | currency: 'EUR' }}
            </span>
          </div>
        </div>

        @if (!userService.currentUser$.value) {
          <div class="flex-r justify-center">
            <button
              type="button"
              class="inwi-text-button-large-primary"
              (click)="toLogin()">
              <div class="button-content">
                <div class="button-text">Anmelden zum fortfahren</div>
              </div>
            </button>
          </div>
        }

        <div class="paypal-button" id="paypal-button-container"></div>
      }
    </div>
  </div>
}
